<template>
    
    <div class="date">
        <!--<input type="hidden" :required="config.required"
               :value="value"
               @input="onAnswerInput" @keyup="onAnswerInput" @paste="onAnswerInput"> -->
        <input type="text" pattern="\d*" inputmode="numeric" :required="config.required"
               :readonly="readonly"
               class="tw-border-0 tw-border-b tw-bg-transparent focus:tw-outline-none focus:tw-ring-0" :class="'date-'+dateConfig[dateFieldOrder[0]].param"
               :style="inputStyles"
               :value="date[dateConfig[dateFieldOrder[0]].param]"
               :maxlength="dateConfig[dateFieldOrder[0]].length" :placeholder="dateConfig[dateFieldOrder[0]].placeholder"
               @input="onAnswerInput($event,dateConfig[dateFieldOrder[0]].param)" @keyup="onAnswerInput($event,dateConfig[dateFieldOrder[0]].param)" @paste="onAnswerInput($event,dateConfig[dateFieldOrder[0]].param)">
        <span class="date-separator">{{ separator }}</span>
        <input type="text" pattern="\d*" inputmode="numeric" :required="config.required"
               :readonly="readonly"
               class="tw-border-0 tw-border-b tw-bg-transparent focus:tw-outline-none focus:tw-ring-0" :class="'date-'+dateConfig[dateFieldOrder[1]].param"
               :style="inputStyles"
               :value="date[dateConfig[dateFieldOrder[1]].param]"
               :maxlength="dateConfig[dateFieldOrder[1]].length" :placeholder="dateConfig[dateFieldOrder[1]].placeholder"
               @input="onAnswerInput($event,dateConfig[dateFieldOrder[1]].param)" @keyup="onAnswerInput($event,dateConfig[dateFieldOrder[1]].param)" @paste="onAnswerInput($event,dateConfig[dateFieldOrder[1]].param)">
        <span class="date-separator">{{ separator }}</span>
        <input type="text" pattern="\d*" inputmode="numeric" :required="config.required"
               :readonly="readonly"
               class="tw-border-0 tw-border-b tw-bg-transparent focus:tw-outline-none focus:tw-ring-0" :class="'date-'+dateConfig[dateFieldOrder[2]].param"
               :style="inputStyles"
               :value="date[dateConfig[dateFieldOrder[2]].param]"
               :maxlength="dateConfig[dateFieldOrder[2]].length" :placeholder="dateConfig[dateFieldOrder[2]].placeholder"
               @input="onAnswerInput($event,dateConfig[dateFieldOrder[2]].param)" @keyup="onAnswerInput($event,dateConfig[dateFieldOrder[2]].param)" @paste="onAnswerInput($event,dateConfig[dateFieldOrder[2]].param)">

    </div>
</template>

<script>
export default {
    name: 'QuestionDate',
    props: {
        value: {
            type: String,
            default: '',
        },
        inputStyles: {
            type: Object,
        },
        readonly: {
            type: Boolean,
            default: false
        },
        config: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            separator: '/',
            date: {
                day: '',
                month: '',
                year: '',
            },
            dateConfig: [
                {
                    param: 'day',
                    length: 2,
                    placeholder: 'DD',
                },
                {
                    param: 'month',
                    length: 2,
                    placeholder: 'MM',
                },
                {
                    param: 'year',
                    length: 4,
                    placeholder: 'YYYY',
                }
            ],
            dateFieldOrder: [0,1,2],
        }
    },
    watch: {
        value: {
            handler(value) {
                this.initValue(value);
                this.answer(value);
            },
            immediate: true,
        },
        'config.separator': {
            handler(separator) {
                this.separator = separator ?? '/';
            },
            immediate: true,
        },
        'config.format': {
            handler(format) {
                if (format === 'YYYYMMDD') this.dateFieldOrder = [2,1,0];
                else if (format === 'MMDDYYYY') this.dateFieldOrder = [1,0,2];
                else this.dateFieldOrder = [0,1,2];
            },
            immediate: true,
        },
    },
    mounted() {
        this.initValue(this.value);
    },
    methods: {
        initValue(value) {
            if (value) {
                let split = value.split('-');
                this.date.year = split[0];
                this.date.month = split[1];
                this.date.day = split[2];
            } else {
                this.date = {day: '', month: '', year: ''}
            }
        },
        onAnswerInput(event, param) {
            this.date[param] = event.target.value;
            if (this.date[param].toString().length > event.target.getAttribute('maxlength'))
                this.date[param] = parseInt(this.date[param].toString().substring(0, event.target.getAttribute('maxlength')));
            
            let date = this.date.year + '-' + this.date.month + '-' + this.date.day;
            this.answer(date);
            
        },
        answer(value) {
            this.$emit('answer', {
                value: value,
                valid: (!value || value === '--' || !!value.match(/^\d{4}-\d{2}-\d{2}$/)),
            });
        }
    },
}
</script>
